module.exports = __webpack_public_path__ + "static/img/spring_tab3_select.d1a8a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab3_select.png
// module id = 360
// module chunks = 32